export enum Brands {
    SchoolScreener = "SchoolScreener",
    CityScreener = "CityScreener",
    WorkScreener = "WorkScreener",
    SchoolScreenerForSchools = "SchoolScreenerForSchools"
  }
  